import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { createSitePage } from 'core-components/sitebuilder/layout/helpers/sitePages'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { selectCurrentSitePageId } from 'core-components/sitebuilder/store/selectors/selectCurrentSitePageId'
import { selectSitePages } from 'core-components/sitebuilder/store/selectors/selectSitePages'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import { isAvailablePage } from './helpers/isAvailablePage'

export const useCurrentSitePage = () => {
  const sitePages = useSelector(selectSitePages)
  const currentSitePageId = useSelector(selectCurrentSitePageId)

  const user = useSelector(selectUser)
  const isAdmin = useMemo(() => user.roleIds.includes('SuperAdmin'), [user.roleIds])

  // TODO: AFTER TEST PERIOD MOVE IT TO MBE API (after release 25.02)
  // DON'T FORGET RoleMultiSelector.tsx, WE NEED UPDATE ROLES BY TREE
  const isAvailable = useCallback(
    (page: ISitePage | undefined): boolean => {
      return isAvailablePage(sitePages, user, page)
    },
    [sitePages, user, isAdmin]
  )

  return useMemo(() => {
    const sitePage = sitePages.find((i) => i.id === currentSitePageId)
    if (isAvailable(sitePage)) {
      if (sitePage) {
        return sitePage
      }
    }
    return createSitePage()
  }, [isAvailable, currentSitePageId, sitePages])
}
